import { render, staticRenderFns } from "./GroupBooking.vue?vue&type=template&id=7a569c4e"
import script from "./GroupBooking.vue?vue&type=script&lang=js"
export * from "./GroupBooking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports